import {
  type TypedUseSelectorHook,
  useDispatch,
  useSelector,
  useStore,
} from "react-redux";
import type { AppDispatch, RootState } from ".";

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
/**
 * The store instance — use when a callback/effect needs the *live* state at call
 * time (via `store.getState()`) rather than a value closed over at render, e.g. a
 * post-mutation refresh that must replay the list's current filter/page, or a
 * streamed-in SSR hydration that must not clobber a newer client write.
 */
export const useAppStore = () => useStore<RootState>();
